(() => {

  class NwtCollup extends HTMLElement {

    connectedCallback() {

      this.trigger = this.querySelector('.collup-trigger');
      this.content = this.querySelector('.collup-content');
      // {% comment %} this.collapsState = localStorage.getItem("nwt-collap-state"); {% endcomment %}

      // console.log('connected', this, this.trigger);

      if (!this.trigger || !this.content) return;

      const inner = document.createElement('div');
      inner.className = 'collup-content-inner';

      while (this.content.firstChild) {
        inner.appendChild(this.content.firstChild);
      }

      this.content.appendChild(inner);
      this.inner = inner;

      document.addEventListener('DOMContentLoaded', () => {
        // console.log('....... domc')
        this.buildSwiperIfExist();
      })
      // {% comment %} document.addEventListener('DOMContentLoaded', () => {
      //   console.log('....... domc')
      //   this.buildSwiperIfExist();
      // }) {% endcomment %}

      this.buildSwiperIfExist();

      // {% comment %} document.addEventListener('change', (e) => {
      //   if(e.target.closest('.drawer__inner')) {
      //     console.log('....... change')
      //     this.buildSwiperIfExist();
      //   }
      // }); {% endcomment %}

      // {% comment %} console.log(this.collapsState); {% endcomment %}

      // {% comment %} if(this.collapsState=='open') {
      //   const open = this.classList.toggle('is-open');
      //   this.toggleOpen(true)
      // } {% endcomment %}

      this.trigger.addEventListener('click', () => {

        const open = this.classList.toggle('is-open');
        this.toggleOpen(open);
        

      });

      this.listenCart();

      this.collupIDs = this.content.querySelectorAll('.collap-prd');

    }

    listenCart() {
      this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // console.log('Cart aggiornato');
        // console.log('----- listenCart ',event);

        const items = event.cartData.items;

        
        // const matchedElements = this.findMatches(items);
        // if(matchedElements?.length > 0) this.adjustCardUx(matchedElements);
        // console.log(matchedElements);
        
      });
    }

    // findMatches(items) {
    //   // console.log('--- findMatches: ',items);
      
    //   if(!items) return;
    //   const isThere = () => {
    //     return [...this.content.querySelectorAll('.collap-prd')].filter(el =>
    //       items.some(item => String(item.product_id) === el.dataset.pId)
    //     );
    //   };
    //   const matchedElements = isThere();
    //   return matchedElements;
    // }

    adjustCardUx(items) {
      items.forEach((item, id) => {
        item.querySelector('.nwt-collap-submit').disabled=true
      });
    }

    disconnectedCallback() {
      if (this.unsubscribeCart) {
        this.unsubscribeCart();
        this.unsubscribeCart = null;
      }
    }

    


    toggleOpen(open) {
      // {% comment %} console.log(open, this.inner, this.trigger, this.content); {% endcomment %}
      this.trigger.setAttribute('aria-expanded', open);

      if (open) {
        this.content.style.maxHeight = this.content.dataset.showSwiper ? (this.inner.scrollHeight+10) + 'px' : this.inner.scrollHeight + 'px';
        // {% comment %} this.content.style.maxHeight = this.inner.scrollHeight + 'px';
        // localStorage.setItem("nwt-collap-state","open"); 


        // 
        // {% comment %} localStorage.setItem("nwt-collap-state","closed"); 
      }

      else {
        this.content.style.maxHeight = '0px';
      }
    }


    buildSwiperIfExist() {

      const showSwiper = this.content.dataset.showSwiper === 'true';

      // Distrugge lo swiper esistente
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      // console.log(showSwiper, typeof Swiper)
      if (showSwiper && typeof Swiper !== 'undefined') {

        const swiper = document.createElement('div');
        swiper.className = 'swiper nwt-collup-swiper';

        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        [...this.inner.querySelectorAll('.collup-item')].forEach(item => {
          item.classList.remove('swiper-slide'); // evita duplicati
          item.classList.add('swiper-slide');
          wrapper.appendChild(item);
        });

        swiper.appendChild(wrapper);

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        swiper.appendChild(pagination);

        this.inner.innerHTML = '';
        this.inner.appendChild(swiper);

        this.swiper = new Swiper(swiper, {
          slidesPerView: 1.10,
          spaceBetween: 6,

          pagination: {
            el: pagination,
            clickable: true
          }

          
        });
      }
    }

  }

  if (!customElements.get('nwt-collup')) {
    customElements.define('nwt-collup', NwtCollup);
  }

})();